import { AuthErrorEnum } from '@/constants/enums/AuthErrorEnum';
import { CookiesKeys } from '@/constants/enums/CookiesEnum';
import { LocalStorageKeys } from '@/constants/enums/LocalStorageEnum';
import { RouteEnum } from '@/constants/enums/RouteEnum';
import { api } from '@/services';
import { isApiSuccess, resolveApiData } from '@/utils/api/functions';
import { UtilCommon } from '@/utils/utilCommon';

export const useThirdPartVerify = () => {
  const user = useUserStore();
  const router = useRouter();
  const { openToast } = useToast();
  const appStore = useAppStore();
  const verifyParamsHandler = async (token: string, isIdToken: boolean, provider: number) => {
    const adId = UtilCommon.getCookie(CookiesKeys.AdId);
    const mgm = UtilCommon.getLocalStorage<string>(LocalStorageKeys.MGMCode);
    const giftCode = UtilCommon.getLocalStorage<string>(LocalStorageKeys.GiftCode);

    window.localStorage.removeItem('from-third-party-email');
    window.localStorage.removeItem('from-third-party-id');
    window.localStorage.removeItem('from-third-party-type');

    localStorage.removeItem(LocalStorageKeys.MGMCode);
    localStorage.removeItem(LocalStorageKeys.GiftCode);
    UtilCommon.removeCookie(CookiesKeys.AdId);

    const res = await api.auth.thirdPartyVerify({
      token,
      isIdToken,
      roleType: 0,
      refMGMCode: mgm ?? '',
      ad_Id: adId ? parseInt(adId) : 0,
      mechType: useIsMobile() ? 'Mobile' : 'PC',
      giftCode: giftCode ?? '',
      thirdPartyProvider: provider //GOOGLE
    });

    if (isApiSuccess(res)) {
      user.token = resolveApiData(res).token;
      user.isFirstLogin = true;
      user.isLogin = true;
      user.isAfterThirdPartVerify = true;
      router.push({ name: RouteEnum.Index });
      return;
    }

    const errorKey = res.data.errorCode?.toString();
    openToast('error', AuthErrorEnum[errorKey as keyof typeof AuthErrorEnum]);
  };

  const googleVerifyHandler = async (token: string) => {
    verifyParamsHandler(token, true, 1);
  };

  const metaVerifyHandler = async (token: string) => {
    verifyParamsHandler(token, false, 2);
  };

  const lineVerifyHandler = async (code: string) => {
    const params = new URLSearchParams();
    params.append('grant_type', 'authorization_code');
    params.append('code', code);
    params.append('redirect_uri', location.origin + '/login');
    params.append('client_id', import.meta.env.VITE_LINE_CLIENTID);
    params.append('client_secret', import.meta.env.VITE_LINE_CLIENTSECRET);
    params.append('bot_prompt', 'aggressive');
    try {
      const response = await fetch(`https://api.line.me/oauth2/v2.1/token`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: params
      });
      if (!response.ok) {
        throw new Error();
      }
      const data = await response.json();

      verifyParamsHandler(data.access_token, false, 3);
    } catch {
      console.log('error');
    }
  };

  const appleVerifyHandler = async (token: string) => {
    verifyParamsHandler(token, false, 4);
  };

  return { googleVerifyHandler, metaVerifyHandler, lineVerifyHandler, appleVerifyHandler };
};
